import { DialogConfirmationComponent } from 'src/shared/Dialogs/dialog-confirmation/dialog.confirmation.component';
import { WallpaperUploadService } from './wallpaperUpload.service';
import { Component, Inject, OnInit } from '@angular/core';
//@ts-ignore
import { MatSnackBar } from "@angular/material/snack-bar";
import { LoggerService } from 'src/shared/logger/logger.service';
import { Levels } from 'src/shared/logger/levels.enum';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogData } from '../dialog-confirmation/dialog.confirmation.component';
import jwt_decode from 'jwt-decode';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'dialog-wallpaperUpload-component',
  templateUrl: './dialog.wallpaperUpload.component.html',
  styleUrls: ['./dialog.wallpaperUpload.component.css'],
  providers: [WallpaperUploadService]
})
export class WallpaperUploadDialogComponent implements OnInit {
  switcher_toggle_navigator = true;

  sort_tree_by = "folder"
  sort_by_list = [
    { value: 'folder', viewValue: 'Folder' },
    { value: 'software_name', viewValue: 'Software Name' },
    { value: 'software_version', viewValue: 'Software Version' },
    { value: 'product_id', viewValue: 'Product Id' }
  ];

  displayedColumns = ["deleteIcon", "name"];
  //items in delete tree
  received_selected_items = [];
  imagesNames: string[] = [];
  selectedImage: string = null;
  imageData: any = {};
  imageSource: any;
  requestSentFlag: boolean = false;

  allowMultipleSelect = false;

  private user_info_obj: { name: string, role: string } = null;


  constructor(private _snackBar: MatSnackBar,
    private loggerService: LoggerService,
    public dialogRef: MatDialogRef<WallpaperUploadDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialog: MatDialog,
    private wallpaperUploadService: WallpaperUploadService,
    private sanitizer: DomSanitizer) {
  }

  ngOnInit(): void {
    if (!this.user_info_obj) { this.user_info_obj = jwt_decode(localStorage.getItem('accessToken')); }

    this.wallpaperUploadService.getAllImages().subscribe(imgs => {
      this.imagesNames = imgs;
    }, err => {
      this.loggerService.log("WallpaperUploadDialogComponent", err.message, Levels.error);
    })
  }

  recieve_selected_multiple_items(items: any) {
    this.received_selected_items = items
    // let checkDb = ""
    // this.received_selected_items.forEach(item => checkDb = checkDb + item.value + ",")
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 8000,
      panelClass: ['mat-toolbar', 'mat-primary']
    });
  }

  getImageUrl() {
    this.wallpaperUploadService.getImage(this.selectedImage).subscribe(imageData => {
      this.imageData = imageData;
      this.imageSource = this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${this.imageData?.base64_encoded_image}`);
    }, err => {
      this.loggerService.log("WallpaperUploadDialogComponent", err.message, Levels.error);
    })
  }

  openConfirmDialog() {
    const dialogRef = this.dialog.open(DialogConfirmationComponent, {
      width: '450px',
      data: { title: "Push wallpaper to units", message: `Confirm pushing wallpaper with title ${this.selectedImage} to ${this.received_selected_items.length} units from VMS` },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.requestSentFlag = true;
        this.wallpaperUploadService.postJobs(this.received_selected_items, this.selectedImage,this.user_info_obj.name).subscribe(data => {
          this.requestSentFlag = false;
          this.openSnackBar("Job pushed successfully.", "Done");
        }, err => {
          this.requestSentFlag = false;
          this.openSnackBar(err.error?.message ? err.error?.message : "Error while processing your request", "Error");
        })
      }
    });
  }

  onNoClick(): void {
    this.data.response = false;
    this.dialogRef.close(this.data.response);
  }
  onYesClick(): void {
    this.data.response = true;
    this.dialogRef.close(this.data.response);
  }

}
